"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualCarUsageChoiceWidgetWithPopup = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var AnnualCarUsageChoiceWidgetWithPopup = exports.AnnualCarUsageChoiceWidgetWithPopup = /** @class */ (function (_super) {
    __extends(AnnualCarUsageChoiceWidgetWithPopup, _super);
    function AnnualCarUsageChoiceWidgetWithPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.businessCommercialUse = "BU-Class3";
        _this.state = {
            lookup: [],
            showInfo: false,
            showCantInsureWarning: false,
            classOfUse: ""
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.toggleCantInsureWarning = _this.toggleCantInsureWarning.bind(_this);
        _this.renderCantInsureWarning = _this.renderCantInsureWarning.bind(_this);
        return _this;
    }
    AnnualCarUsageChoiceWidgetWithPopup.prototype.componentDidMount = function () {
        var classOfUse = this.props.interaction.vehicles[this.vehicleIndex].classOfUse;
        if (classOfUse !== null && classOfUse !== undefined) {
            this.setState({ classOfUse: classOfUse });
        }
        this.fetchLookupValues("carUsage");
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "form-group ".concat(this.state.showInfo ? 'background-color-grey inner-content negative-margin width-auto' : '') },
            this.state.showCantInsureWarning && this.renderCantInsureWarning(),
            React.createElement("div", { className: "media", onClick: function () {
                    _this.setState({ showInfo: !_this.state.showInfo });
                } },
                React.createElement("div", { className: "row custom-polar-panel-text" }, this.renderHeader())),
            React.createElement("div", { className: this.state.showInfo ? 'display-block border-100 pb-2' : 'display-none' },
                React.createElement("div", { className: "card shadow-none rounded" },
                    React.createElement("div", { className: this.state.showInfo ? 'card-body light-blue-background rounded' : 'background-color-white rounded' },
                        React.createElement("p", { className: "card-text", role: "alert" },
                            React.createElement("span", { className: "font-weight-bold" }, "Social, Domestic, Pleasure and Commuting (SDP+C)"),
                            " - includes commuting to a single place of work provided no business visits are made on the way."),
                        React.createElement("p", { className: "card-text", role: "alert" },
                            React.createElement("span", { className: "font-weight-bold" }, "Social, Domestic and Pleasure "),
                            " - includes day-to-day driving, like driving to visit friends and family or going shopping."),
                        React.createElement("p", { className: "card-text", role: "alert" },
                            React.createElement("span", { className: "font-weight-bold" }, "Business use non-commercial"),
                            " - as well as social, domestic and pleasure use, your car is used for travelling to more than one place of work or the car is used in relation to your occupation (e.g. travelling to another location for work). This doesn't cover for travelling sales people."),
                        React.createElement("p", { className: "card-text", role: "alert" },
                            React.createElement("span", { className: "font-weight-bold" }, "Business use commercial"),
                            " - as well as social, domestic and pleasure use, there is cover for where the driver of the car is a travelling or commercial sales person. Unfortunately, we\u2019re not able to cover you if you\u2019re using your car for business use commercial.")))),
            React.createElement("div", null, this.renderOptions()),
            this.validationErrorsPresent() && this.bindFromField(this.props.question.interactionField) === undefined &&
                React.createElement("div", { className: "invalid-feedback d-block" }, "Please answer this to carry on")));
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.handleOnChangeEvent = function (event) {
        var value = event.currentTarget.value;
        this.executeEvent("change");
        if (value) {
            this.setState({
                classOfUse: value
            });
            if (value === this.businessCommercialUse) {
                this.toggleCantInsureWarning();
                this.props.onStateChange(this.props.question.interactionField, null);
            }
            else {
                this.props.onStateChange(this.props.question.interactionField, value);
            }
        }
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.renderHeader = function () {
        var _this = this;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        return (React.createElement("label", { className: "no-wrap-label" },
            React.createElement("span", { className: "whitespace-normal-span" },
                "What is this ",
                vehicle.make,
                ", ",
                vehicle.model,
                vehicle.registrationNumber && " (".concat(vehicle.registrationNumber, ")"),
                " used for?"),
            "\u00A0",
            React.createElement("span", { className: "info-button-container" },
                React.createElement("div", { tabIndex: 0, role: "button", className: this.state.showInfo ? "info-button selected" : "info-button", "aria-label": "Info button for more information about car usage", onKeyPress: function () {
                        _this.setState({ showInfo: !_this.state.showInfo });
                    } }))));
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.validationErrorsPresent = function () {
        var _this = this;
        return Object.keys(this.props.validations).map(function (key) { return _this.props.validations[key]; }).some(function (v) { return !v.valid; });
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.renderCantInsureWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleCantInsureWarning });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showCantInsureWarning, toggle: this.toggleCantInsureWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleCantInsureWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "fixed-alert-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flow-attention.svg"), alt: "warning-sign" }),
                        React.createElement("span", { className: "ml-3 text-blue-2 fs-20 font-weight-medium" }, "Sorry\u2026"))),
                React.createElement(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light" },
                    React.createElement(React.Fragment, null, "...we can't insure vehicles being used for commercial travelling or hire and reward purposes.")),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("div", { className: "w-100 d-flex flex-column justify-content-between" },
                        React.createElement("div", null,
                            React.createElement(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-primary btn-next-no-arrow", onClick: this.toggleCantInsureWarning }, "OK, I understand")))))));
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.toggleCantInsureWarning = function () {
        this.setState({ showCantInsureWarning: !this.state.showCantInsureWarning });
    };
    AnnualCarUsageChoiceWidgetWithPopup.prototype.renderOptions = function () {
        var _this = this;
        var optionList = [];
        this.state.lookup.forEach(function (item) {
            optionList.push(React.createElement("div", { key: item.id, className: "custom-control margin-bottom-20-padding-left-0 car-usage-choice" },
                React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: _this.props.question.name + "-" + item.id, id: _this.props.question.name + "-" + item.id, value: item.id, checked: _this.state.classOfUse !== _this.businessCommercialUse && _this.state.classOfUse === item.id, onChange: _this.handleOnChangeEvent }),
                React.createElement("label", { id: 'driver-label', className: "checkbox-label label-bg-transparent", htmlFor: _this.props.question.name + "-" + item.id }, item.value)));
        });
        return (React.createElement("div", null, optionList));
    };
    ;
    AnnualCarUsageChoiceWidgetWithPopup.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
            _this.setState({ lookup: lookupValues });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualCarUsageChoiceWidgetWithPopup.prototype, "changelogRecorder", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualCarUsageChoiceWidgetWithPopup.prototype, "lookupService", void 0);
    return AnnualCarUsageChoiceWidgetWithPopup;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualCarUsageChoiceWidgetWithPopup.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualCarUsageChoiceWidgetWithPopup.js
// module id = 3176
// module chunks = 0